import { render, staticRenderFns } from "./RealFriendMeetingConfirmPage.vue?vue&type=template&id=689c0f56&scoped=true"
import script from "./RealFriendMeetingConfirmPage.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingConfirmPage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingConfirmPage.vue?vue&type=style&index=0&id=689c0f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c0f56",
  null
  
)

export default component.exports